import { createApp } from "vue"
import "./style.css"
import App from "./App.vue"
import router from "/src/router/index"
import { createPinia } from "pinia"
import * as Sentry from "@sentry/vue"
import { initGtm } from "./utils/gtm"
import { AccessTokenExpiredError } from "./http/http"

const app = createApp(App)

initGtm(import.meta.env.VITE_GTM_ID ?? "GTM-PXNFFPGS")

// Register Sentry
// Configuration reference: https://docs.sentry.io/platforms/javascript/guides/vue/
if (import.meta.env.VITE_SENTRY_ENABLE === "true") {
    Sentry.init({
        app,
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [Sentry.browserTracingIntegration({ router })],
        environment: import.meta.env.VITE_ENVIRONMENT,
        initialScope: {
            tags: { app: "frontend" },
        },
        beforeSend(event, hint) {
            // Don't log AccessTokenExpiredError in Sentry. It's just used internally
            //  to know when to try refreshing the token.
            if (
                hint?.originalException instanceof AccessTokenExpiredError ||
                event.exception?.values?.[0]?.type === "AccessTokenExpiredError"
            )
                return null

            return event
        },
        tracesSampleRate: 0.0,
    })
}

app.use(router)
app.use(createPinia())
app.mount("#app")
